import { createSelector } from 'reselect';
import { name, initialState } from './slice';

export const packageDepartureSelector = (state) => state[name] || initialState;

export const packageDepartureSearchSelector = (state) => state[name].search;

export const packageDepartureTypeSelector = (state) =>
  state[name].departureType;

export const packageDepartureDestinySelector = (state) => state[name].destinyID;

export const packageDepartureRemovePacketIDSelector = (state) =>
  state[name].removePacketID;

export const packageDepartureLoadedSelector = (state) => state[name].loaded;

const makePackageDepartureSelector = () =>
  createSelector(packageDepartureSelector, (substate) => substate);

export default makePackageDepartureSelector;
